/**
 * dualListBox.js - Bootstrap + jQuery dual-list (field chooser) replacement.
 * No jQuery UI required. Uses HTML5 drag-and-drop.
 * API compatible with legacy fieldChooser for drop-in replacement.
 *
 * Usage: chooser = $("#container").dualListBox($('#sourceList'), $('#destList'), options);
 * Or alias: $("#container").fieldChooser($('#sourceList'), $('#destList'));
 *
 * List API: getSourceList(), getDestinationList() return list objects with:
 *   getFields(), getSelection(), clearSelection(suppressEvent), add(content),
 *   selectField(field), toggleFieldSelection(field), selectTo(field),
 *   selectAt(index), extendSelection(up), scrollToField(field)
 * Events: selectionChanged (event, list), listChanged (event, movedNodes, targetList)
 */
(function ($) {
	'use strict';

	var DATA_KEY = 'dualListBox';
	var LIST_MIME = 'application/x-duallistbox-item';

	function createFieldList($parent, tabIndex, chooserRef) {
		var $list = $parent;
		$list.addClass('dlb-field-list fc-field-list');
		$list.attr('tabIndex', tabIndex);

		var selectedIndex = -1;
		var extendedSelectionIndex = -1;

		function prepareListFields($content) {
			$content.addClass('dlb-field fc-field');
			$content.attr('tabIndex', tabIndex);
			$content.attr('draggable', 'true');

			$content.off('click.dlb');
			$content.on('click.dlb', function (e) {
				e.stopPropagation();
				e.preventDefault();
				var $field = $(this);
				var list = chooserRef.getFieldList($field);
				if (e.ctrlKey || e.metaKey) {
					list.toggleFieldSelection($field);
				} else if (e.shiftKey) {
					list.selectTo($field);
				} else {
					list.selectField($field);
				}
			});
		}

		prepareListFields($list.children());

		$list.selectAt = function (index) {
			this.clearSelection(true);
			var fields = $list.getFields();
			if (index >= fields.length) index = fields.length - 1;
			var $selected = index >= 0 ? fields.eq(index) : null;
			if ($selected && $selected.length) {
				$selected.addClass('dlb-selected fc-selected');
				selectedIndex = $selected.index();
				$list.scrollToField($selected);
			} else {
				selectedIndex = -1;
			}
			$list.trigger('selectionChanged', [$list]);
		};

		$list.extendSelection = function (up) {
			var fields = $list.getFields().filter(':visible');
			var ext = extendedSelectionIndex < 0 ? selectedIndex : extendedSelectionIndex;
			var newIndex = ext;
			var extend = true;
			if (up) {
				if (newIndex < 0) {
					newIndex = fields.length;
					selectedIndex = newIndex - 1;
				}
				if (extendedSelectionIndex > selectedIndex) extend = false;
				else newIndex--;
			} else {
				if (newIndex < 0) selectedIndex = 0;
				if (extendedSelectionIndex < selectedIndex) extend = false;
				else newIndex++;
			}
			if (newIndex < 0 || newIndex >= fields.length) return;
			var $target = fields.eq(newIndex);
			if (extend) {
				$target.addClass('dlb-selected fc-selected');
			} else {
				$target.removeClass('dlb-selected fc-selected');
				newIndex += up ? -1 : 1;
			}
			extendedSelectionIndex = newIndex;
			$list.scrollToField($target);
			$list.trigger('selectionChanged', [$list]);
		};

		$list.selectField = function ($field) {
			this.clearSelection(true);
			$field.addClass('dlb-selected fc-selected');
			selectedIndex = $field.index();
			$list.trigger('selectionChanged', [$list]);
		};

		$list.toggleFieldSelection = function ($field) {
			$field.toggleClass('dlb-selected fc-selected');
			if ($field.hasClass('dlb-selected')) {
				selectedIndex = $field.index();
				extendedSelectionIndex = -1;
			} else if (selectedIndex === $field.index()) {
				selectedIndex = $list.children('.dlb-selected').first().index();
			}
			$list.trigger('selectionChanged', [$list]);
		};

		$list.selectTo = function (fieldOrIndex) {
			var fieldIndex = typeof fieldOrIndex === 'object' ? fieldOrIndex.index() : fieldOrIndex;
			if (selectedIndex === -1) selectedIndex = 0;
			var children = $list.children();
			var low = Math.min(selectedIndex, fieldIndex);
			var high = Math.max(selectedIndex, fieldIndex);
			children.removeClass('dlb-selected fc-selected');
			for (var i = low; i <= high; i++) {
				children.eq(i).addClass('dlb-selected fc-selected');
			}
			extendedSelectionIndex = fieldIndex;
			$list.trigger('selectionChanged', [$list]);
		};

		$list.getSelectedIndex = function () { return selectedIndex; };
		$list.getExtendedSelectionIndex = function () {
			return extendedSelectionIndex < 0 ? selectedIndex : extendedSelectionIndex;
		};
		$list.getSelection = function () {
			return this.children('.dlb-selected, .fc-selected');
		};
		$list.clearSelection = function (suppressEvent) {
			selectedIndex = -1;
			extendedSelectionIndex = -1;
			this.children().removeClass('dlb-selected fc-selected');
			if (!suppressEvent) $list.trigger('selectionChanged', [$list]);
		};
		$list.add = function ($content) {
			prepareListFields($content);
			$content.appendTo($list);
			return $list;
		};
		$list.getFields = function () {
			return $list.children();
		};
		$list.scrollToField = function ($field) {
			if (!$field || !$field.length) return;
			var listTop = $list.position().top;
			var listScrollTop = $list.scrollTop();
			var listHeight = $list.height();
			var listScrollBottom = listScrollTop + listHeight;
			var fieldHeight = $field.outerHeight();
			var fieldTop = listScrollTop + $field.position().top - listTop;
			var fieldBottom = fieldTop + fieldHeight;
			if (fieldTop < listScrollTop) {
				$list.scrollTop(fieldTop);
			} else if (fieldBottom > listScrollBottom) {
				$list.scrollTop(listScrollTop + (fieldBottom - listScrollBottom));
			}
		};

		// ---- HTML5 drag and drop ----
		$list.data('dlb-chooser', chooserRef);

		// Track drag context on the chooser so we can support both
		// cross-list moves and intra-list reordering.

		$list.on('dragstart.dlb', '.dlb-field, .fc-field', function (e) {
			var $field = $(this);
			var list = chooserRef.getFieldList($field);
			if (list.getSelection().index($field[0]) < 0) {
				list.selectField($field);
			}
			var $selection = list.getSelection();
			// Store drag context on the chooser
			chooserRef.data('dlb-drag-context', {
				fromList: list,
				selection: $selection
			});

			$field.addClass('dlb-dragging');
			$selection.addClass('dlb-dragging');

			e.originalEvent.dataTransfer.setData(LIST_MIME, 'drag');
			e.originalEvent.dataTransfer.effectAllowed = 'move';
			e.originalEvent.dataTransfer.setData('text/plain', $selection.length + ' item(s)');
		});

		$list.on('dragend.dlb', '.dlb-field, .fc-field', function () {
			chooserRef.removeData('dlb-drag-context');
			$list.find('.dlb-dragging').removeClass('dlb-dragging');
			$list.find('.dlb-drop-target').removeClass('dlb-drop-target');
		});

		$list.on('dragover.dlb', function (e) {
			e.preventDefault();
			e.originalEvent.dataTransfer.dropEffect = 'move';

			// Highlight potential drop target within this list
			var $targetField = $(e.target).closest('.dlb-field, .fc-field');
			var $prev = $list.find('.dlb-drop-target');
			if ($targetField.length && $targetField.parent()[0] === $list[0]) {
				if ($prev[0] !== $targetField[0]) {
					$prev.removeClass('dlb-drop-target');
					$targetField.addClass('dlb-drop-target');
				}
			} else {
				$prev.removeClass('dlb-drop-target');
			}
		});

		$list.on('drop.dlb', function (e) {
			e.preventDefault();
			var chooser = $list.data('dlb-chooser');
			if (!chooser) return;
			var drag = chooser.data('dlb-drag-context') || {};
			var fromList = drag.fromList || chooser.getFieldList($(e.target).closest('.dlb-field, .fc-field'));
			if (!fromList) return;

			var $selection = drag.selection || fromList.getSelection();
			if (!$selection || !$selection.length) return;

			var $targetField = $(e.target).closest('.dlb-field, .fc-field');
			var isSameList = (fromList[0] === $list[0]);

			// Intra-list reordering or cross-list insert
			if ($targetField.length && $targetField.parent()[0] === $list[0]) {
				// Insert selection before the target field
				$selection.insertBefore($targetField);
			} else {
				// Append to end of target list
				$selection.appendTo($list);
			}

			$list.find('.dlb-drop-target').removeClass('dlb-drop-target');

			if (!isSameList) {
				// For cross-list moves, clear selection from the source list
				fromList.clearSelection(true);
				fromList.trigger('selectionChanged', [fromList]);
			}

			// Keep selection on the moved items in the target list
			$selection.addClass('dlb-selected fc-selected');
			$list.trigger('selectionChanged', [$list]);

			chooser.trigger('listChanged', [$selection, $list]);
		});

		return $list;
	}

	function init(container, sourceList, destinationList, options) {
		var $container = $(container);
		if ($container.data(DATA_KEY)) return $container.data(DATA_KEY);

		var opts = $.extend({}, $.fn.dualListBox.defaults, options);
		var tabIndex = parseInt($container.attr('tabIndex'), 10) || 0;
		$container.removeAttr('tabIndex');

		var $source = $(sourceList).addClass('dlb-source-fields fc-source-fields');
		var $dest = $(destinationList).addClass('dlb-destination-fields fc-destination-fields');

		var chooser = $container;
		var sourceListObj = createFieldList($source, tabIndex, chooser);
		var destListObj = createFieldList($dest, tabIndex, chooser);

		var currentList = null;
		var lastSelectionList = null;

		function onSelectionChanged(event, list) {
			if (lastSelectionList && lastSelectionList[0] !== list[0]) {
				var other = list[0] === sourceListObj[0] ? destListObj : sourceListObj;
				other.clearSelection(true);
			}
			lastSelectionList = list;
		}

		sourceListObj.on('selectionChanged', onSelectionChanged);
		destListObj.on('selectionChanged', onSelectionChanged);

		$source.on('focusin.dlb', function () { currentList = sourceListObj; });
		$source.on('focusout.dlb', function () { if (currentList === sourceListObj) currentList = null; });
		$dest.on('focusin.dlb', function () { currentList = destListObj; });
		$dest.on('focusout.dlb', function () { if (currentList === destListObj) currentList = null; });

		$(document).on('keydown.dlb.dualListBox', function (e) {
			if (!currentList) return;
			// Alt + Up/Down: reorder selected items within the current list
			if (e.altKey && !e.shiftKey && (e.which === 38 || e.which === 40)) {
				e.preventDefault();
				e.stopPropagation();
				var moveUp = (e.which === 38);
				var fields = currentList.getFields().filter(':visible');
				var $selection = currentList.getSelection();
				if (!$selection.length || !fields.length) return;

				var chooser = $container.data(DATA_KEY);
				if (!chooser) return;

				if (moveUp) {
					var firstIdx = fields.index($selection.first());
					if (firstIdx <= 0) return;
					var $before = fields.eq(firstIdx - 1);
					$selection.insertBefore($before);
					currentList.scrollToField($selection.first());
				} else {
					var lastIdx = fields.index($selection.last());
					if (lastIdx < 0 || lastIdx >= fields.length - 1) return;
					var $after = fields.eq(lastIdx + 1);
					$selection.insertAfter($after);
					currentList.scrollToField($selection.last());
				}

				currentList.trigger('selectionChanged', [currentList]);
				chooser.trigger('listChanged', [$selection, currentList]);
			} else if (e.which === 38) {
				e.preventDefault();
				e.stopPropagation();
				if (e.shiftKey) currentList.extendSelection(true);
				else currentList.selectAt(Math.max(0, currentList.getSelectedIndex() - 1));
			} else if (e.which === 40) {
				e.preventDefault();
				e.stopPropagation();
				var idx = currentList.getSelectedIndex();
				var len = currentList.getFields().filter(':visible').length;
				if (e.shiftKey) currentList.extendSelection(false);
				else currentList.selectAt(idx < 0 ? (len - 1) : Math.min(len - 1, idx + 1));
			} else if (e.which === 27) {
				e.preventDefault();
				currentList.selectAt(-1);
			}
		});

		chooser.getOptions = function () { return opts; };
		chooser.getSourceList = function () { return sourceListObj; };
		chooser.getDestinationList = function () { return destListObj; };
		chooser.getFieldList = function ($field) {
			return $field.parent().hasClass('dlb-source-fields') ? sourceListObj : destListObj;
		};
		chooser.destroy = function () {
			$(document).off('keydown.dlb.dualListBox');
			$source.off('.dlb');
			$dest.off('.dlb');
			sourceListObj.off('selectionChanged');
			destListObj.off('selectionChanged');
			chooser.removeData(DATA_KEY);
		};

		if (opts.filterInput && $.dualListBox && $.dualListBox.filter) {
			$.dualListBox.filter(chooser, opts.filterInput);
		}
		if (opts.buttons && $.dualListBox && $.dualListBox.buttons) {
			$.dualListBox.buttons(chooser, opts.buttons);
		}

		// Live header counts: update (n) next to source/destination titles
		function updateHeaderCounts() {
			var $srcCount = chooser.find('.dlb-source-header .dlb-header-count');
			var $destCount = chooser.find('.dlb-dest-header .dlb-header-count');
			if ($srcCount.length) {
				$srcCount.text('(' + sourceListObj.getFields().length + ')');
			}
			if ($destCount.length) {
				$destCount.text('(' + destListObj.getFields().length + ')');
			}
		}
		updateHeaderCounts();
		chooser.on('listChanged', updateHeaderCounts);

		$container.data(DATA_KEY, chooser);
		return chooser;
	}

	$.fn.dualListBox = function (sourceList, destinationList, options) {
		if (this.length === 0) return this;
		return init(this.eq(0), sourceList, destinationList, options);
	};

	$.fn.dualListBox.defaults = {
		filterInput: null,  // selector for search input; requires dualListBox.filter.js
		buttons: null       // { container: '#id', labels?: {} }; requires dualListBox.buttons.js
	};

	// Backward-compatible alias for existing fieldChooser usage
	$.fn.fieldChooser = $.fn.dualListBox;

}(jQuery));
